import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

interface AgGridPaginationProps {
  page: number;
  pageSize: number;
  rowCount: number;
  onPaginationChange: (model: { page: number; pageSize: number }) => void;
  hidden?: boolean;
  pageSizeOptions?: number[];
}

const AgGridPagination: React.FC<AgGridPaginationProps> = ({
  page,
  pageSize,
  rowCount,
  onPaginationChange,
  hidden = false,
  pageSizeOptions = [10, 25, 50, 100],
}) => {
  if (hidden) return null;

  const totalPages = Math.ceil(rowCount / pageSize);

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onPaginationChange({ page: 0, pageSize: Number(e.target.value) });
  };

  return (
    <div className="flex items-center justify-end gap-4 px-4 py-3">
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-800">Rows per page:</span>
        <select
          value={pageSize}
          onChange={handlePageSizeChange}
          className="border-none bg-transparent px-1 text-sm text-gray-800 cursor-pointer focus:outline-none"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPaginationChange({ page: page - 1, pageSize })}
          disabled={page === 0}
          className="rounded p-1 text-gray-800 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
        >
          <MdChevronLeft className="h-5 w-5" />
        </button>
        <button
          onClick={() => onPaginationChange({ page: page + 1, pageSize })}
          disabled={page >= totalPages - 1}
          className="rounded p-1 text-gray-800 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
        >
          <MdChevronRight className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default AgGridPagination;
